module.exports = __webpack_public_path__ + "img/Sokka-256.b1510e77.png";